export default "__VITE_ASSET__CG_eeV_3__"